// eslint-disable-next-line @typescript-eslint/no-empty-function
const debuglog = process.env.NODE_ENV === 'development' ? console.debug : (): void => {};

export { debuglog };
